// Возврат киоска на главный (idle) экран с ПОЛНОЙ перезагрузкой страницы.
//
// Очищаем ТОЛЬКО cookie Яндекс.Метрики (_ym_*). После перезагрузки тег
// Метрики инициализируется заново, генерирует новый _ym_uid => для Метрики
// это новый посетитель => первый хит (kiosk_enter на /welcome) открывает
// НОВЫЙ визит. Так каждый гость = отдельная сессия воронки.
//
// Остальные cookie (auth, настройки приложения, localStorage) не трогаем.
export function rebootToIdle(target = '/'): void {
    document.cookie.split(';').forEach((cookie) => {
        const name = cookie.trim().split('=')[0];
        if (!name.startsWith('_ym_')) return;

        const expired = 'expires=Thu, 01 Jan 1970 00:00:00 GMT';
        document.cookie = `${name}=;path=/;${expired}`;
        document.cookie = `${name}=;path=/;domain=${location.hostname};${expired}`;
        document.cookie = `${name}=;path=/;domain=.${location.hostname};${expired}`;
    });

    window.location.href = target;
}